<template>
  <div>
    <router-link :to="{ name: resource_type.toLowerCase() + '-languages', query: additionalModalData() }" class="blue_text" target="_blank">
      <b><u>שפות:</u></b>
    </router-link>
    <div v-if="languages.length > 0">
      <div class="vertical_space"></div>
      <div v-for="language in languages" :key="language.id" >
        <a @click="editLanguage(language)" class="blue_text">
          <b>{{ "רמת " + language.language.name + ": " }}</b>
          <b>קריאה - </b> {{ languages_helper.getTextByValue(language.reading) }},
          <b>כתיבה - </b> {{ languages_helper.getTextByValue(language.writing) }},
          <b>דיבור - </b> {{ languages_helper.getTextByValue(language.verbal) }}
        </a>
        <div class="vertical_space"></div>
      </div>
    </div>
    <p v-else>שפות לא הוזנו</p>
    <a @click="createLanguage" class="button is-info">Create Language</a>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import LanguagesHelper from '@/custom/classes/languages_helper.js'
export default {
  name: 'resource-languages',
  props: {
    resource_id: {
      type: Number,
      default: -1
    },
    resource_data: {
      type: Object,
      default: () => {}
    },
    resource_type: {
      type: String,
      default: 'Applicant'
    },
    languages: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      languages_helper: new LanguagesHelper()
    }
  },
  methods: {
    editLanguage (language) {
      let payload = { designator: this.resource_type + '-languages-form-modal', component_name: this.resource_type + 'LanguagesForm', data: language, modal_title: language.language.name }
      this.create({ ...payload, ...this.additionalModalData() })
    },
    createLanguage () {
      let payload = { designator: this.resource_type + '-languages-form-modal', component_name: this.resource_type + 'LanguagesForm', is_create: true, modal_title: 'Create new Language' }
      this.create({ ...payload, ...this.additionalModalData() })
    },
    additionalModalData () {
      let payload = {}
      if (this.resource_type == 'Applicant') {
        payload.applicant_id = this.resource_id
      }
      if (this.resource_type == 'Position') {
        payload.position_id = this.resource_id
        payload.company_id = this.resource_data.company.resource_id
        payload.position_status = this.resource_data.status
      }
      if (this.resource_type == 'Company') {
        payload.company_id = this.resource_id
      }
      return payload
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
